<div class="navbar">
  <div class="logo" [routerLink]="['dashboard']">
    <img src="img/logo-green-black.png" class="main-logo" />
  </div>

  <div class="navbar-spacer"></div>

  <div class="environment-badge" *ngIf="isDevelopment">
    <p-tag value="Development" severity="contrast" class="environment-tag" />
  </div>

  <button
    type="button"
    class="user-menu-trigger"
    (click)="userMenu.toggle($event)"
  >
    <div class="info">
      <div class="username" *ngIf="authService.user?.username">
        {{ authService.user.username }}
      </div>
      <div class="user-id">
        ID: {{ authService.user?.user_id }} ({{
          authService.user?.role.role_name
        }})
      </div>
    </div>

    <div class="profile">
      <i class="pi pi-user"></i>
    </div>

    <i class="pi pi-angle-down trigger-chevron"></i>
  </button>

  <p-menu
    #userMenu
    [popup]="true"
    [model]="userMenuItems"
    appendTo="body"
    styleClass="navbar-user-menu"
  />
</div>
